import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Search: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='M604.83 581.28l-42.43-42.43-.1.1-112.27-105.24a244.82 244.82 0 0 1-12.62 13.62c-2.71 2.71-5.47 5.34-8.29 7.9l126.23 119.01 49.47 49.47c11.72-11.72 11.72-30.71 0-42.43zM316.38 460.72c-39.93 0-77.68-16.47-106.3-46.38-27.77-29.03-43.7-68.41-43.7-108.04 0-82.71 67.29-150 150-150s150 67.29 150 150c0 39.63-15.93 79.01-43.7 108.04-28.62 29.91-66.37 46.38-106.3 46.38zm0-274.43c-66.17 0-120 53.83-120 120s54.95 124.43 120 124.43 120-56.98 120-124.43-53.83-120-120-120z' />
  </IconBase>
));

Search.displayName = 'Search';

export default Search;
